import { render, staticRenderFns } from "./PopoverPage.vue?vue&type=template&id=6f4c5da4&"
import script from "./PopoverPage.vue?vue&type=script&lang=js&"
export * from "./PopoverPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports